// Mock data for the Rips by Triumph clone (frontend-only)
import { Zap, EyeOff, Clock, Mail, Lock, BadgeCheck } from "lucide-react";

export const brand = {
  name: "RIPS",
  subtitle: "BY TRIUMPH",
  logo: "https://87a0575d3962fefc240b0aaa9c395d91.cdn.bubble.io/cdn-cgi/image/w=64,h=64,f=auto,dpr=1,fit=contain/f1781913384455x878534431881213800/logo.webp",
};

export const nav = [
  { label: "Home", id: "home" },
  { label: "Pricing", id: "pricing" },
  { label: "FAQ", id: "faq" },
];

export const hero = {
  badge: "LEGENDARY SOFTWARE ACCESS",
  title: "Rips Proxy",
  description:
    "Unleash the most powerful key-access toolkit built for competitive rips users. Premium scripts, lightning-fast execution, and battle-tested reliability.",
  bullets: [
    "Instant license key & script delivery to your email",
    "Anonymous, secure cryptocurrency payments",
    "Flexible time-based access from 7 to 31 days",
  ],
  banner: "Keys & scripts emailed instantly after payment.",
  image:
    "https://images.unsplash.com/photo-1649341566122-0bd5e7a3eef8?ixid=M3w2OTk3Mjl8MHwxfHJhbmRvbXx8fHx8fHx8fDE3ODE5MTM1MDd8&ixlib=rb-4.1.0&w=900&q=80",
};

export const plans = [
  {
    id: "starter",
    tag: "STARTER",
    name: "3 Day Access",
    price: 150,
    days: 3,
    popular: false,
    delivery: "Instant Email Delivery",
    features: [
      "Full Rips toolkit access",
      "All premium scripts included",
      "3 days of key validity",
    ],
  },
  {
    id: "popular",
    tag: "MOST POPULAR",
    name: "31 Day Access",
    price: 650,
    days: 31,
    popular: true,
    delivery: "Instant Email Delivery",
    features: [
      "Full Rips toolkit access",
      "All premium scripts included",
      "31 days of key validity",
    ],
  },
  {
    id: "legendary",
    tag: "LEGENDARY",
    name: "LIFETIME",
    price: 1300,
    days: "Lifetime",
    popular: false,
    delivery: "Instant Email Delivery",
    features: [
      "Full Rips toolkit access",
      "All premium scripts included",
      "Lifetime key validity \u2014 never expires",
      "Access to any new cheats developed",
      "Lifetime unban bot",
      "Can resell anything I create in the future",
    ],
  },
];

export const faqs = [
  {
    q: "How do I purchase a Rips license?",
    a: "Choose your preferred time-based plan above and click 'Choose Plan'. Enter your email, select a cryptocurrency, and send the exact amount to the displayed wallet address. Once your payment is confirmed on-chain, your license key and scripts are generated automatically.",
  },
  {
    q: "How are keys and scripts delivered?",
    a: "Everything is delivered instantly to the email you provide at checkout. The moment your crypto payment is confirmed, your unique license key and the full premium script pack are sent straight to your inbox \u2014 no waiting, no manual approval.",
  },
  {
    q: "Which cryptocurrencies are accepted?",
    a: "We accept the most popular and widely available coins including Bitcoin (BTC), Ethereum (ETH), Litecoin (LTC), and USDT. Always verify the wallet address and network before sending your payment.",
  },
  {
    q: "Are crypto payments refundable?",
    a: "No. All cryptocurrency payments are final and non-refundable. Please double-check the wallet address and the exact amount before sending funds. If you run into trouble, open a support ticket and our team will help.",
  },
];

export const cryptoGuide = {
  title: "Don't Have Crypto?",
  subtitle: "Getting crypto is quick and easy.",
  option: {
    heading: "Option 1: Buy with Apple Pay",
    steps: [
      "Download IronWallet from the App Store.",
      "Create a new wallet and securely save your recovery phrase.",
      "Open the wallet and select Buy Crypto.",
      "Choose the cryptocurrency you'd like to purchase.",
      "Select Apple Pay (or card if that is the other available payment method) as your payment method (if available).",
      "Complete the purchase and your crypto will appear in your wallet.",
    ],
  },
  important: {
    heading: "Important",
    notes: [
      "Never share your recovery phrase with anyone.",
      "Always double-check wallet addresses before sending funds.",
      "Purchase methods and verification requirements may vary by provider and location.",
    ],
  },
  footnote: "Need help? Open a support ticket and our team will assist you through the process.",
};

export const footer = {
  blurb:
    "Unlock legendary power. Time-based key access licenses delivered the moment your payment lands.",
  delivery: "Instant email delivery of keys & scripts after every confirmed payment.",
  copyright: "\u00A9 2026 Rips by Triumph. All rights reserved.",
  links: ["Pricing", "FAQ", "Admin"],
  disclaimer:
    "All cryptocurrency payments are final and non-refundable. Please verify the wallet address and amount before sending.",
};

export const wallets = [
  { coin: "Bitcoin", symbol: "BTC", address: "bc1qx9rips4legendkeyaccess7triumph0powerusrz" },
  { coin: "Ethereum", symbol: "ETH", address: "0x9F3aRips14LegendKeyAccess7Triumph0PowerUsr" },
  { coin: "Litecoin", symbol: "LTC", address: "ltc1qrips31legendkeyaccesstriumphpowerusrz0" },
  { coin: "Tether", symbol: "USDT", address: "TRipsLegend14KeyAccess7Triumph0PowerUsrz31" },
];

export const trustItems = [
  { icon: Zap, label: "Lightning Execution" },
  { icon: Mail, label: "Instant Delivery" },
  { icon: Lock, label: "Anonymous Payments" },
  { icon: EyeOff, label: "Undetectable" },
  { icon: Clock, label: "Flexible Access" },
  { icon: BadgeCheck, label: "Premium Scripts" },
];
